import React, { Component } from 'react';
import moment from 'moment';
import {
  caretBackCircleOutline as caretLeft,
  caretForwardCircleOutline as caretRight,
  closeOutline as close,
} from 'ionicons/icons';

import {
  IonGrid,
  IonRow,
  IonCol,
  IonItem,
  IonTitle,
  IonLabel,
  IonIcon,
  IonChip,
  IonModal,
  IonContent,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonButton,
  IonFooter,
  IonText,
  IonTextarea,
  IonCheckbox,
  withIonLifeCycle,
  IonLoading,
  IonSpinner,
} from '@ionic/react';

import ReservationsService from '../services/reservations';
import ProfileService from '../services/profile';
import { preselectedDate, reservationPath } from '../utils/preselectedDate';

class Calendar extends Component {
  constructor(props) {
    super(props);

    this.serviceRef = React.createRef('');
    this.profileRef = React.createRef('');
    this.selectedTimeRef = React.createRef('');
    this.pickedDateRef = React.createRef('');
    this.selectedStaffIdRef = React.createRef('');
    this.noteRef = React.createRef('');

    this.state = {
      availableDate: null,
      pickedDateTime: null,
      isModalOpen: false,
      isActive: '',
      termsAccepted: false,
      calendarDayProgression: [],
      loading: false,
      loadingSlots: false,
      profile: false,
      service: [],
      ShopService: [],
    };
  }

  async ionViewWillEnter() {
    if (this.props.loader) {
      this.props.loader.current.show();
    }

    this.setState({ profile: undefined });
    try {
      const { id } = this.props.match.params;

      const response = await ReservationsService.availableDate({ id });
      const { service, availableDate } = response.data;

      this.setState({ service });
      await this.setState({ availableDate });
      this.serviceRef.current = service;

      this.setCalendarlimitsDate();
      if (!this.state.profile) {
        const { data } = await ProfileService.me();
        if (data?.data) {
          await this.setState({ profile: data.data });
          this.profileRef.current = data.data;
        }
      }
    } catch (e) {
      console.error(e);
    } finally {
      this.props.loader.current.dismiss();
    }

    // Link del chatbot con ?date=: se il calendario offre quel giorno, si apre sul
    // suo mese con il giorno selezionato e gli orari già caricati.
    const giorno = preselectedDate(this.props.location?.search, this.state.availableDate);
    if (giorno) {
      const mese = moment(giorno);
      if (this.props.goToMonth) this.props.goToMonth(mese);
      this.setCalendarlimitsDate(mese);
      this.setState({ isActive: giorno });
      await this.fetchDateTime(giorno);
    }
  }

  async ionViewWillLeave() {
    this.setState({ isModalOpen: false });
    this.setState({ termsAccepted: false });
    this.setState({ pickedDateTime: null });
    this.setState({ availableDate: null });
    this.setState({ isActive: '' });
    this.setState({ calendarDayProgression: [] });

    this.serviceRef.current = '';
    this.profileRef.current = '';
    this.selectedTimeRef.current = '';
    this.pickedDateRef.current = '';
    this.selectedStaffIdRef.current = '';
    this.noteRef.current = '';
  }

  async fetchDateTime(fullDate) {
    // Gli orari del giorno precedente si tolgono subito, così lo spinner
    // mostra che si stanno caricando quelli del giorno scelto.
    this.setState({ loadingSlots: true, pickedDateTime: null });

    try {
      const {
        data: { availableSlots },
        data: { pickedDate },
      } = await ReservationsService.fetchTime(this.serviceRef.current.id, fullDate);

      await this.setState({ pickedDateTime: availableSlots });
      this.pickedDateRef.current = pickedDate;
    } catch (e) {
      console.error(e);
    } finally {
      this.setState({ loadingSlots: false });
    }
  }

  async submitHandler(that) {
    that.setState({ loading: true });
    let endAppointment = moment(`${that.pickedDateRef.current} ${that.selectedTimeRef.current}`)
      .add(that.serviceRef.current.duration, 'm')
      .subtract(1, 's')
      .format('HH:mm:ss');

    try {
      const {
        data: { success, message, data: reservationData },
      } = await ReservationsService.saveReservation({
        user_id: that.profileRef.current.id,
        service_id: that.serviceRef.current.id,
        staff_id: that.selectedStaffIdRef.current,
        day: that.pickedDateRef.current,
        start_appointment: that.selectedTimeRef.current,
        end_appointment: endAppointment,
        note: that.noteRef.current,
        terms_accepted: that.state.termsAccepted,
      });

      if (success && reservationData?.payment_required) {
        // Servizio con acconto: si chiude la modale e si passa alla schermata di pagamento
        that.setState({ isModalOpen: false });
        that.props.history.push(`/app/reservations/${reservationData.reservation_id}/payment`);
      } else if (success) {
        await that.props.toast.current.add({ message });
        await this.fetchDateTime(that.pickedDateRef.current);
        that.setState({ isModalOpen: false });
        that.props.history.push('/app/reservations');
      } else {
        await that.props.toast.current.add({ message, color: 'danger' });
        that.setState({ isModalOpen: false });
        this.reset();
      }
    } catch (e) {
      console.error(e);
      that.props.toast.current.add({
        message: `Problema nella conferma della prenotazione.`,
        color: 'danger',
      });

      delete that.props.toast.current.onDidDismiss;
    } finally {
      that.setState({ loading: false });
    }
  }

  reset() {
    this.pickedDateRef.current = '';
    this.setState({ pickedDateTime: null });
    this.setState({ isActive: '' });
  }

  setCalendarlimitsDate(month = this.props.momentDate) {
    const arr = [];
    let _arr = [];
    let startOfCalendar = month.clone().startOf('month');
    let endOfCalendar = month.clone().endOf('month');
    let startOfMonthNum = Number(startOfCalendar.format('d')) - 1;
    let endOfMonthNum = Number(endOfCalendar.format('d')) - 1;

    startOfCalendar = this.setCalendarLimits(startOfCalendar, startOfMonthNum, true);
    endOfCalendar = this.setCalendarLimits(endOfCalendar, endOfMonthNum, false);

    while (startOfCalendar.format('YYYY-MM-DD') !== endOfCalendar.format('YYYY-MM-DD')) {
      _arr.push(startOfCalendar.clone());
      if (Number(startOfCalendar.format('d')) === 0) {
        arr.push(_arr);
        _arr = [];
      }

      startOfCalendar = startOfCalendar.add(1, 'd');
    }

    this.setState({ calendarDayProgression: arr });
  }

  setCalendarLimits(obj, num, bool) {
    if (num === -1) num = 6;
    if (bool) {
      if (num !== 0) {
        obj = obj.subtract(num, 'd');
      }
    } else {
      if (num !== 6) {
        obj = obj.add(7 - num, 'd');
      } else if (num === 6) {
        obj = obj.add(1, 'd');
      }
    }

    return obj;
  }

  render() {
    const { availableDate, isActive, pickedDateTime, isModalOpen, profile, service, termsAccepted, loadingSlots } =
      this.state;

    // Un servizio senza termini può arrivare con null o con una stringa di soli
    // spazi: in entrambi i casi non c'è niente da far accettare.
    const bookingTerms = (service?.booking_terms || '').trim();

    return (
      <>
        <IonGrid>
          <IonRow className="ion-margin-vertical">
            <IonCol size="1">
              <IonIcon
                icon={caretLeft}
                style={{ height: '30px', width: '30px' }}
                onClick={() => {
                  this.props.prevMonth();
                  this.setCalendarlimitsDate();
                  this.reset();
                }}
              />
            </IonCol>

            <IonCol>
              <IonTitle className="ion-text-uppercase ion-text-center">{this.props.momentDate.format('MMMM')}</IonTitle>
            </IonCol>

            <IonCol className="ion-padding-end" size="1">
              <IonIcon
                className="ion-float-end"
                icon={caretRight}
                style={{ height: '30px', width: '30px' }}
                onClick={() => {
                  this.props.nextMonth();
                  this.setCalendarlimitsDate();
                  this.reset();
                }}
              />
            </IonCol>
          </IonRow>
        </IonGrid>

        <IonItem className="ion-no-margin ion-no-padding">
          <table style={{ width: '100%', margin: 'auto auto 10px auto' }}>
            <thead>
              <tr>
                <th>Lun</th>
                <th>Mar</th>
                <th>Mer</th>
                <th>Gio</th>
                <th>Ven</th>
                <th>Sab</th>
                <th>Dom</th>
              </tr>
            </thead>

            <tbody>
              {this.state.calendarDayProgression.map((weekDate) => {
                return (
                  <tr key={weekDate[0].format('MM-DD')}>
                    {weekDate.map((dayDate) => {
                      const day = dayDate.format('DD');
                      const fullDate = dayDate.format('YYYY-MM-DD');
                      let isDisabled = true;
                      let color = 'light';

                      if (availableDate && availableDate.indexOf(fullDate) !== -1) {
                        isDisabled = false;
                        color = isActive === fullDate ? 'middle' : 'dark';
                      }

                      return (
                        <td key={fullDate}>
                          <IonChip
                            id={fullDate}
                            color={color}
                            outline={true}
                            disabled={isDisabled}
                            onClick={() => {
                              if (isDisabled) return;
                              this.setState({ isActive: fullDate });
                              this.fetchDateTime(fullDate);
                            }}
                          >
                            <IonLabel>{day}</IonLabel>
                          </IonChip>
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </IonItem>

        {loadingSlots && (
          <div className="ion-text-center ion-padding">
            <IonSpinner />
          </div>
        )}

        {pickedDateTime &&
          (Array.isArray(pickedDateTime) && pickedDateTime.length === 0 ? (
            <p>Nessuna fascia oraria disponibile</p>
          ) : (
            <IonItem className="ion-margin-vertical ion-padding-bottom">
              <IonCol className="ion-align-self-start">
                <IonLabel>
                  <h3 style={{ marginBottom: '8px' }}>Orari disponibili</h3>
                </IonLabel>

                {pickedDateTime.map((timeInterval, index) => {
                  return (
                    <IonChip
                      key={index}
                      color="success"
                      outline={true}
                      onClick={() => {
                        if (profile) {
                          this.setState({ isModalOpen: true, termsAccepted: false });
                          this.selectedTimeRef.current = timeInterval.time;
                          this.selectedStaffIdRef.current = timeInterval.staffId;
                        } else {
                          const redirectUrl = reservationPath(service.id, this.state.isActive);
                          this.props.history.replace(`/auth/login?redirect=${encodeURIComponent(redirectUrl)}`);
                        }
                      }}
                    >
                      <IonLabel>{timeInterval.time}</IonLabel>
                    </IonChip>
                  );
                })}
              </IonCol>
            </IonItem>
          ))}

        {isModalOpen && (
          <IonModal
            isOpen={isModalOpen}
            onDidDismiss={() => {
              this.selectedTimeRef.current = '';
              this.selectedStaffIdRef.current = '';
              this.noteRef.current = '';
              this.setState({ isModalOpen: false, termsAccepted: false });
            }}
          >
            <IonHeader>
              <IonToolbar>
                <IonButtons slot="end">
                  <IonButton
                    onClick={() => {
                      this.selectedTimeRef.current = '';
                      this.selectedStaffIdRef.current = '';
                      this.setState({ isModalOpen: false, termsAccepted: false });
                      this.noteRef.current = '';
                    }}
                  >
                    <IonIcon icon={close} />
                  </IonButton>
                </IonButtons>
                <IonTitle>Riepilogo</IonTitle>
              </IonToolbar>
            </IonHeader>

            <IonContent fullscreen>
              <ion-item-group>
                <ion-item-divider>
                  <IonLabel className="ion-text-uppercase" color="dark">
                    <b>Dati Personali</b>
                  </IonLabel>
                </ion-item-divider>

                <IonItem lines="none">
                  <IonLabel>
                    <h4 className="ion-text-uppercase">Nome:</h4>
                    <p className="ion-text-capitalize">{this.profileRef.current.name}</p>
                  </IonLabel>
                </IonItem>

                <IonItem lines="none">
                  <IonLabel>
                    <h4 className="ion-text-uppercase">Email:</h4>
                    <p>{this.profileRef.current.email}</p>
                  </IonLabel>
                </IonItem>

                <IonItem>
                  <IonLabel>
                    <h4 className="ion-text-uppercase">Telefono:</h4>
                    <p>{this.profileRef.current.phone_number}</p>
                  </IonLabel>
                </IonItem>
              </ion-item-group>

              <ion-item-group>
                <ion-item-divider>
                  <IonLabel className="ion-text-uppercase" color="dark">
                    <b>Prenotazione</b>
                  </IonLabel>
                </ion-item-divider>

                <IonItem lines="none">
                  <IonLabel>
                    <h4 className="ion-text-uppercase">Servizio:</h4>
                    <p>{this.serviceRef.current.name}</p>
                  </IonLabel>
                </IonItem>

                <IonItem lines="none">
                  <IonLabel>
                    <h4 className="ion-text-uppercase">Giorno:</h4>
                    <p>{moment(this.pickedDateRef.current).format('dddd | DD MMMM YYYY')}</p>
                  </IonLabel>
                </IonItem>

                <IonItem lines="none">
                  <IonLabel>
                    <h4 className="ion-text-uppercase">Ora:</h4>
                    <p>{this.selectedTimeRef.current}</p>
                  </IonLabel>
                </IonItem>

                <IonItem lines="none">
                  <IonLabel>
                    <h4 className="ion-text-uppercase">Prezzo:</h4>
                    <p>{this.serviceRef.current.price} €</p>
                  </IonLabel>
                </IonItem>

                <IonItem>
                  <IonLabel>
                    <h4 className="ion-text-uppercase">Durata:</h4>
                    <p>{this.serviceRef.current.duration} min</p>
                  </IonLabel>
                </IonItem>
              </ion-item-group>

              <ion-item-group>
                <ion-item-divider>
                  <IonLabel className="ion-text-uppercase" color="dark">
                    <b>Note</b>
                  </IonLabel>
                </ion-item-divider>

                <IonItem lines="none">
                  <IonLabel>
                    <h4 className="ion-text-uppercase">Note al farmacista:</h4>
                  </IonLabel>
                </IonItem>

                <IonItem lines="none">
                  <IonTextarea
                    type="text"
                    name="note"
                    placeholder="Indica qui se hai richieste particolari da inviare al Farmacista"
                    value={this.noteRef.current}
                    onIonChange={(e) => (this.noteRef.current = e.detail.value)}
                  />
                </IonItem>
              </ion-item-group>

              {!!this.state.service?.payment_required && (
                <IonItem lines="none">
                  <IonText color="primary">
                    <p style={{ fontSize: '13px' }}>
                      Acconto da pagare con PayPal: € {Number(this.state.service.deposit_amount).toFixed(2)}
                    </p>
                  </IonText>
                </IonItem>
              )}

              {this.state.service?.require_confirmation && (
                <IonItem lines="none">
                  <IonText color="warning">
                    <p style={{ fontSize: '13px' }}>⚠️ La prenotazione richiederà conferma da parte della farmacia.</p>
                  </IonText>
                </IonItem>
              )}

              {/*
                I termini vanno letti prima di essere accettati, quindi il testo sta
                sopra e la checkbox porta un'etichetta breve: con termini lunghi una
                label integrale diventerebbe un muro di testo cliccabile.
              */}
              {!!bookingTerms && (
                <ion-item-group>
                  <ion-item-divider>
                    <IonLabel className="ion-text-uppercase" color="dark">
                      <b>Termini e condizioni</b>
                    </IonLabel>
                  </ion-item-divider>

                  <IonItem lines="none">
                    <IonText className="ion-text-wrap">
                      <p style={{ fontSize: '13px', whiteSpace: 'pre-wrap' }}>{bookingTerms}</p>
                    </IonText>
                  </IonItem>

                  <IonItem lines="none">
                    <IonCheckbox
                      slot="start"
                      checked={termsAccepted}
                      onIonChange={(e) => this.setState({ termsAccepted: e.detail.checked })}
                    />
                    <IonLabel className="ion-text-wrap">Accetto i termini e le condizioni</IonLabel>
                  </IonItem>
                </ion-item-group>
              )}
            </IonContent>

            <IonFooter>
              <IonToolbar>
                {this.profileRef.current ? (
                  <IonButton
                    className="ion-margin-horizontal"
                    expand="block"
                    color="success"
                    disabled={!!bookingTerms && !termsAccepted}
                    onClick={() => this.submitHandler(this)}
                  >
                    Conferma prenotazione
                  </IonButton>
                ) : (
                  <IonButton
                    expand="block"
                    color="light"
                    className="ion-margin-horizontal"
                    onClick={() => {
                      this.setState({ isModalOpen: false });
                      this.props.history.push(`/auth/login?redirect=/app/reservations`);
                    }}
                  >
                    Accedi per richiedere informazioni
                  </IonButton>
                )}
              </IonToolbar>
            </IonFooter>

            <IonLoading isOpen={this.state.loading} message={'Salvataggio in corso...'} duration={0} />
          </IonModal>
        )}
      </>
    );
  }
}

export default withIonLifeCycle(Calendar);
